<template>
  <v-timeline
    align-top
    dense
  >
    <v-timeline-item
      color="accent"
      small
      fill-dot
    >
      <v-row class="pt-3">
        <!-- <v-flex sm3>{{order.delivery_date}}</v-flex> -->
        <v-col>
          <strong>{{order.origin.company}}, {{order.origin.company_ref}}</strong>
          <div class="caption">
            {{order.origin.address.street}} {{order.origin.address.street_number}}, {{order.origin.address.city}} {{order.origin.address.postal_code}}, {{order.origin.address.country}}
            <v-btn
              small
              @click="gotoLocationDetail(order.origin.id)"
              icon
            >
              <v-icon small>launch</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-timeline-item>
    <v-timeline-item
      small
      color="accent"
      hide-dot
    >
      <v-row class="pt-3" >
        <v-col>
          <div class="caption">
            {{order.packages.length}} {{$tc('orders.package', order.packages.length)}}
          </div>
        </v-col>
      </v-row>
    </v-timeline-item>
    <v-timeline-item
      small
      color="accent"
      fill-dot
    >
      <v-row class="pt-3" >
        <!-- <v-flex sm3>{{order.delivery_date}}</v-flex> -->
        <v-col>
          <!-- <strong>{{order.destination.name}}</strong> - {{order.destination.type}} -->
          <strong>{{order.destination.company}}, {{order.destination.company_ref}}</strong>
          <div class="caption">
            {{order.destination.address.street}} {{order.destination.address.street_number}}, {{order.destination.address.city}} {{order.destination.address.postal_code}}, {{order.destination.address.country}}
            <v-btn
              small
              @click="gotoLocationDetail(order.destination.id)"
              icon
            >
              <v-icon small>launch</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
import router from '@/router'

export default {
  name: 'OrderDetailOverviewTimeline',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  methods: {
    gotoLocationDetail (locationID) {
      router.push({
        name: 'LocationDetail',
        params: { locationID: locationID }
      })
    }
  }
}
</script>
